import React from 'react'

import { useTranslation } from '@/core/i18n/useTranslation'
import { Button } from '@/shared/components/atoms/Button'

interface SaveDiscardButtonsProps {
	isSaving?: boolean
	onSave: () => void
	onDiscard: () => void
}

export const SaveDiscardButtons: React.FC<SaveDiscardButtonsProps> = ({
	isSaving = false,
	onSave,
	onDiscard,
}) => {
	const { t } = useTranslation('common')

	return (
		<div className="flex items-center gap-2">
			<Button
				type="button"
				variant="outline"
				onClick={onDiscard}
				disabled={isSaving}
				className="h-9 rounded-full px-6"
			>
				{t('actions.discardChanges')}
			</Button>
			<Button
				type="button"
				onClick={onSave}
				disabled={isSaving}
				className="h-9 rounded-full px-6"
			>
				{isSaving ? t('common.saving') : t('actions.saveChanges')}
			</Button>
		</div>
	)
}
